import type { SVGProps } from "react";

export default function GmailIcon(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M3.23791 16.7567V4.77701H16.7628V16.7567" fill="#F2F2F2" />
      <path
        d="M10 11.4367L3.23757 16.7571L3.03867 6.21566"
        fill="black"
        fillOpacity="0.05"
      />
      <path
        d="M3.23768 16.7569H2.09403C1.49735 16.7569 1.00011 16.2596 1.00011 15.6132V4.37564H3.23768V16.7569Z"
        fill="#D54C3F"
      />
      <path
        d="M13.0331 16.7571H16.8619V5.17146H1.34807"
        fill="black"
        fillOpacity="0.08"
      />
      <path d="M2.09392 3.28196H17.9061L10 8.90075" fill="#F2F2F2" />
      <path
        d="M16.7623 16.7569H17.906C18.5027 16.7569 18.9999 16.2596 18.9999 15.6132V4.37564H16.7623V16.7569Z"
        fill="#B63524"
      />
      <path
        d="M2.09386 4.37564L9.99994 10.0939L17.906 4.37564"
        stroke="#DE5145"
        strokeWidth="2.18785"
        strokeLinecap="round"
      />
    </svg>
  );
}
